"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftOverviewSections = void 0;
const react_1 = __importDefault(require("react"));
const shift_infobox_1 = require("../components/shift-infobox");
const agenda_section_1 = require("./agenda-section");
const base_info_section_1 = require("./base-info-section");
const custom_attributes_section_1 = require("./custom-attributes-section");
const emergency_section_1 = require("./emergency-section");
const experience_section_1 = require("./experience-section");
const localities_section_1 = require("./localities-section");
const manual_pause_section_1 = require("./manual-pause-section");
const note_section_1 = require("./note-section");
const overtime_section_1 = require("./overtime-section");
const shift_template_section_1 = require("./shift-template-section");
const template_section_1 = require("./template-section");
const transfer_section_1 = require("./transfer-section");
const ShiftOverviewSections = () => {
    return (react_1.default.createElement("div", { style: {
            display: 'flex',
            flexFlow: 'column',
            gap: '1rem',
            position: 'relative',
        } },
        react_1.default.createElement(shift_template_section_1.ShiftTemplateSection, null),
        react_1.default.createElement(template_section_1.TemplateSection, null),
        react_1.default.createElement(base_info_section_1.BaseInfoSection, null),
        react_1.default.createElement(shift_infobox_1.ShiftInfoBox, null),
        react_1.default.createElement(manual_pause_section_1.ManualPauseSection, null),
        react_1.default.createElement(overtime_section_1.OvertimeSection, null),
        react_1.default.createElement(agenda_section_1.AgendaSection, null),
        react_1.default.createElement(emergency_section_1.EmergencySection, null),
        react_1.default.createElement(note_section_1.NoteSection, null),
        react_1.default.createElement(experience_section_1.ExperienceSection, null),
        react_1.default.createElement(localities_section_1.LocalitiesSection, null),
        react_1.default.createElement(transfer_section_1.TransferSection, null),
        react_1.default.createElement(custom_attributes_section_1.CustomAttributesSection, null)));
};
exports.ShiftOverviewSections = ShiftOverviewSections;
